import { v4 } from 'uuid';
import { formatCurrency } from '../utils/currencyFormatter';
/**
 * Returns the cart for a Recurly purchase.
 *
 * This cart object is intended to be provided to DIP (Dropin-payments component) so that it has a
 * cart interface provided by Recurly instead of the Cart Service.
 */
var getRecurlyCart = function getRecurlyCart(_ref) {
  var externalId = _ref.externalId,
    cartItems = _ref.cartItems,
    previewPurchase = _ref.previewPurchase,
    currency = _ref.currency;
  if (!previewPurchase) {
    return null;
  }
  var total = previewPurchase.totalAmount,
    tax = previewPurchase.tax,
    subtotal = previewPurchase.subTotal,
    discount = previewPurchase.totalDiscount;
  return {
    orderSummary: {
      subtotal: Number(subtotal),
      discount: discount,
      tax: tax,
      totalWithCurrencyFormat: formatCurrency(total, currency),
      subtotalWithCurrencyFormat: formatCurrency(subtotal, currency),
      taxWithCurrencyFormat: formatCurrency(tax, currency),
      total: Number(total),
      currencyName: currency,
      taxDetails: {
        tax: tax,
        taxWithCurrencyFormat: formatCurrency(tax, currency),
        label: null
      },
      orderGiftCodeBalance: 0,
      totalCoveredByScholarship: false
    },
    cartId: v4(),
    items: cartItems,
    externalId: externalId,
    subtotalWithCurrencyFormat: formatCurrency(subtotal, currency)
  };
};
export default getRecurlyCart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getRecurlyCart.js
// module id = 4135
// module chunks = 11